module.exports = __webpack_public_path__ + "img/big3-8.a7e20c85.jpg";